/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Styled components for Button Table
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */
import styled from 'styled-components';

const ButtonTableContainerStyled = styled.div.attrs({
    className: 'button-table',
})`
      border-radius: 18px;

      & .button .button__button-content {
          display: flex;
      }

      & .button .button__button-content:disabled {
          opacity: 0.3;
      }

      & .button_circle .button__button-content{
          width: 32px;
      }
`;

export {
    ButtonTableContainerStyled,
};
